<template>
    <div class="app bg">
        <DefaultHeader/>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="navFilter"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer/>
            </AppSidebar>
            <main class="main">
                <Breadcrumb :list="list"/>
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
                <!--aside-->
                <DefaultAside/>
            </AppAside>
        </div>
        <DefaultFooter/>
    </div>
</template>

<script>
    import {
        Sidebar as AppSidebar,
        SidebarFooter,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
        Aside as AppAside,
        Breadcrumb
    } from '@coreui/vue'
    import DefaultAside from './DefaultAside'
    import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
    import DefaultHeader from './DefaultHeader'
    import DefaultFooter from './DefaultFooter'
    import {mapGetters, mapState} from "vuex";

    export default {
        name: 'DefaultContainer',
        components: {
            AppSidebar,
            AppAside,
            Breadcrumb,
            DefaultAside,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            DefaultFooter,
            DefaultHeader
        },
        data() {
            return {
                navArray: [
                    // {
                    //   name: "Dashboard",
                    //   url: "/dashboard",
                    //   icon: "icon-speedometer",
                    //   meta: {
                    //     permission:"Dashboard"
                    //   },
                    // },
                    {
                        name: "Issued Proposal",
                        url: "/proposal/list",
                        icon: "icon-star",
                        meta: {
                            permission: "Proposal_List"
                        }
                    },
                    {
                        name: "Create Proposal",
                        url: "/proposal/create",
                        icon: "icon-star",
                        meta: {
                            permission: "Proposal_Create"
                        }
                    },
                    {
                        name: "User Management",
                        url: "",
                        icon: "icon-user",
                        meta: {
                            permission: "Create_user"
                        },
                        children: [
                            {
                                name: "User Roles",
                                url: "/roles",
                                icon: "icon-user",
                                meta: {
                                    permission: "Create_role"
                                }
                            },
                            {
                                name: "User Accounts",
                                url: "/users",
                                icon: "icon-user",
                                meta: {
                                    permission: "Create_user"
                                }
                            }
                        ]
                    },
                    {
                        name: 'Audit Trail',
                        url: '/activity_log',
                        icon: 'icon-star',
                        meta: {
                            permission: "View_Audit_Trail"
                        }
                    }
                ]
            }
        },
        methods: {
            parseJwt(token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                return jsonPayload;
            }
        },
        computed: {
            ...mapGetters("login", ["loggedIn"]),
            ...mapState("login", ["access_token" , "system_role"]),
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            },
            navFilter() {
                let payload = [];
                if (this.access_token) {
                    payload = JSON.parse(this.parseJwt(this.access_token));
                }
                let nvFiltr = [];
                this.navArray.forEach((value, index) => {
                    const navItem = value;

                    if (navItem.children) {

                        const ch = navItem.children;
                        const children = [];
                        ch.forEach((valuech, index) => {
                            if (valuech.meta) {
                                var permission = valuech.meta.permission;
                                if (payload.scopes) {
                                    if (payload.scopes.indexOf(permission) > -1) {
                                        children.push(valuech);
                                    }
                                }
                            }
                        });
                        navItem.children = children;
                    }
                    if (navItem.meta) {
                      if(this.system_role != 4){
                        var permission = navItem.meta.permission;
                        if (payload.scopes) {
                          if (payload.scopes.indexOf(permission) > -1 || navItem.title) {
                            nvFiltr.push(navItem);
                          }
                        }
                      }
                    }
                    if (navItem.title) {
                        nvFiltr.push(navItem);
                    }
                });
                return nvFiltr;
            }
        }
    }
</script>

<style scoped>
    .bg {
        /* The image used for web */
        background: url("~@/assets/bcg-image.jpg");

        /* Full height */
        height: 100vh;
        overflow: hidden;
        /* Center and scale the image nicely */
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>
